// @flow

import React, { type Node } from 'react';

import { useIncomingPayment, getCountry, getRedirectUrlAfterPayment } from '@tectonics/prs/incoming-payment';

import { theme } from '../../commons/theme';

import { Button, Link } from '../../commons/atoms';

export function BackToAppButton(): Node {
  const incomingPayment = useIncomingPayment();
  const redirectUrl = getRedirectUrlAfterPayment(incomingPayment);

  return (
    <Button as={Link} href={redirectUrl} background={theme.colors.black(0)} block>
      <ButtonMessageByCountry />
    </Button>
  );
}

function ButtonMessageByCountry(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return 'Voltar para o app';

    case 'bo':
    case 'cl':
    case 'co':
    case 'mx':
    case 'pe':
    case 'ec':
    case 'ar':
    case 'uy':
      return 'Volver a la aplicación';

    default:
      throw new Error(`Button message not mapped for country ${country}`);
  }
}
